import { setNestedObjectValues } from "formik";
import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { AssetMoveRequestApi } from "../../../services/AssetService";
import { toast } from "react-toastify";
import { searchLocation } from "../../../services/UserService";
const AssetMoveRequestModal = ({
  visible,
  onClose,
  afterSubmit,
  id,
  locationId,
}) => {
  const [locationOptionLoading, setLocationOptionLoading] = useState(false);
  const [locationOption, setLocatioOption] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    to_location: "",
    remarks: "",
  });
  const [error, setError] = useState({
    to_location: "",
  });
  const getLocation = () => {
    setLocationOptionLoading(true);
    searchLocation()
      .then((res) => {
        const filteredLocations = (res?.data?.results || []).filter(
          (loc) => loc.value !== locationId
        );
        setLocatioOption(filteredLocations||[]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLocationOptionLoading(false);
      });
  };
  useEffect(() => {
    setForm({ ...form, to_location: selectedLocation?.value || "" });
    if (selectedLocation?.value) {
      setError({ ...error, to_location: "" });
    }
  }, [selectedLocation]);
  useEffect(() => {
    if (visible) {
      getLocation();
    } else {
      handleReset();
    }
  }, [visible]);
  const handleReset = () => {
    setLocatioOption([]);
    setSelectedLocation(null);
    setForm({
      to_location: "",
      remarks: "",
    });
    setError({
      location: "",
    });
  };
  const handleRequestSubmit = () => {
    setLoading(true);
    AssetMoveRequestApi(id, form)
      .then((res) => {
        toast.success("Move Request");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleInternalSubmit = () => {
    let errorObj = {};
    if (!form?.to_location) {
      errorObj.to_location = true;
    }
    setError(errorObj);
    if (Object.keys(errorObj).length === 0) {
      handleRequestSubmit();
    }
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Move Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-2 gy-2">
            <div className="col-12">
              <label className="form-label text-dark">Move To</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="Select Location"
                isLoading={locationOptionLoading}
                options={locationOption}
                value={selectedLocation}
                onChange={setSelectedLocation}
              />
              {error?.location && (
                <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                  Manadatory Field
                </div>
              )}
            </div>
            <div className="col-12">
              <label className="form-label text-dark">Remark</label>
              <textarea
                className="form-control"
                rows="1"
                placeholder="Optional"
                name="remark"
                value={form?.remarks}
                onChange={(e) => {
                  setForm({ ...form, remarks: e.target.value || "" });
                }}
              ></textarea>
              <code className="text-light">
                <strong>Note</strong>: This asset stays under your
                responsibility until the transfer is accepted by the assigned
                recipient or their authority
              </code>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span className="btn btn-outline-danger" onClick={onClose}>
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleInternalSubmit}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Move
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AssetMoveRequestModal;
